import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// prettier-ignore
const FinancialInstitutionSchema = withDefaults({
  'type': 'financial-institution',
  'fields': [
    {
      'kind': 'attribute',
      'name': 'name'
    },
    {
      'kind': 'attribute',
      'name': 'publicOrdinalValue'
    },
    {
      'kind': 'attribute',
      'name': 'isActive'
    },
    {
      'kind': 'attribute',
      'name': 'isPublic'
    },
    {
      'kind': 'attribute',
      'name': 'manifestInstitutionId'
    },
    {
      'kind': 'attribute',
      'name': 'legacyId'
    },
    {
      'kind': 'attribute',
      'name': 'surrogateUserId'
    },
    {
      'kind': 'attribute',
      'name': 'fundSource'
    },
    {
      'kind': 'attribute',
      'name': 'canLinkOn'
    },
    {
      'kind': 'attribute',
      'name': 'statusMessage'
    },
    {
      'kind': 'attribute',
      'name': 'hasObservabilityInstructions'
    },
    {
      'kind': 'attribute',
      'name': 'servicerAddressType'
    },
    {
      'kind': 'attribute',
      'name': 'accountNumberPattern'
    },
    {
      'kind': 'attribute',
      'name': 'activeConnectedAccountsCount'
    },
    {
      'kind': 'belongsTo',
      'name': 'user',
      'type': 'user',
      'options': {
        'async': false,
        'inverse': null
      }
    },
    {
      'kind': 'belongsTo',
      'name': 'logo',
      'type': 'public-asset',
      'options': {
        'async': false,
        'inverse': null
      }
    },
    {
      'kind': 'hasMany',
      'name': 'accounts',
      'type': 'account',
      'options': {
        'async': false,
        'inverse': null
      }
    },
    {
      'kind': 'hasMany',
      'name': 'accountTransactions',
      'type': 'account-transaction',
      'options': {
        'async': false,
        'inverse': null
      }
    },
    {
      'kind': 'hasMany',
      'name': 'postalAddresses',
      'type': 'postal-address',
      'options': {
        'async': false,
        'inverse': 'postalAddressable',
        'as': 'postal-addressable'
      }
    },
    {
      'kind': 'hasMany',
      'name': 'attachments',
      'type': 'attachment',
      'options': {
        'async': false,
        'inverse': null
      }
    },
    {
      'kind': 'hasMany',
      'name': 'financialInsitutionPatterns',
      'type': 'financial-institution-pattern',
      'options': {
        'async': false,
        'inverse': null
      }
    },
    {
      'kind': 'hasMany',
      'name': 'creditors',
      'type': 'creditor',
      'options': {
        'async': false,
        'inverse': null
      }
    }
  ]
});

export default FinancialInstitutionSchema;
